import { ReactNode } from 'react';

import { Box, Link, Text } from '@joinrepublic/dls-ui-kit';
import { colors } from '@joinrepublic/republic-ui-levelup-theme';

// Raw palette, not a semantic token -- see the note in `user-menu.tsx`.
const LEVELUP_ITEM_HOVER_BG = colors.whiteAlpha['25'];

/**
 * One row of `LevelUpUserMenu`'s dropdown. Split out of `levelup-user-menu.tsx` into its own
 * file alongside the icons (this pushed that file over the repo's `max-lines` lint limit).
 *
 * Menu item destinations are placeholders for now (`href="#"`, no-op) except
 * Log out, which navigates to LevelUp's own logout endpoint (see
 * `levelupLogoutUrl`) - per explicit request, the rest will get real
 * destinations in a follow-up.
 */
export function MenuRow({
  icon,
  label,
  href,
  color = colors.white,
}: {
  icon: ReactNode;
  label: string;
  href: string;
  color?: string;
}) {
  return (
    <Link
      href={href}
      variant="noDecoration"
      display="flex"
      alignItems="center"
      gap="2"
      w="185px"
      h="40px"
      px="4"
      borderRadius="6px"
      _hover={{ bg: LEVELUP_ITEM_HOVER_BG, textDecoration: 'none' }}
      onClick={href === '#' ? (e) => e.preventDefault() : undefined}
    >
      <Box color={color} display="flex" alignItems="center">
        {icon}
      </Box>
      <Text fontWeight="500" color={color} sx={{ fontSize: '14px' }}>
        {label}
      </Text>
    </Link>
  );
}
